import { isPS, isRS } from '@/utils';
import type { ProjectTableColumn } from '../../projects/_models/project-filter';

export const PROJECT_BASE_DIR = isRS() && !isPS() ? '/rs/project' : '/project';

export const PS_MAX_CASCADER_SELECTION = 5;

export const PS_MAX_KEYWORD_SEARCH_LENGTH = 30;

const _MAX_PAYMENTS_WITH_COMMA = 9 + 2;

export const FIXED_PROJECTS_TABLE_COLUMN_KEYS: ProjectTableColumn[] = [
  'name',
  'ministryName',
  'projectNumber',
  'organizationLabel',
  'task',
  'purpose',
];
const _DEFAULT_RS_PROJECTS_TABLE_COLUMN_KEYS: ProjectTableColumn[] = [
  'ministryName',
  'projectNumber',
  'startYear',
  'budgetData',
  'finalizedAmountForInitialBudget',
  ...(!isPS() ? (['isPublished'] satisfies ProjectTableColumn[]) : []),
  'mainPayment',
  'paymentAmount',
];

const _getDefaultKSProjectsTableColumnKeys = (fundSheetType: string | null) => {
  switch (fundSheetType) {
    case 'local-government':
      return DEFAULT_KS_LOCAL_GOVERNMENT_PROJECTS_TABLE_COLUMN_KEYS;
    case 'investment':
      return DEFAULT_KS_INVESTMENT_PROJECTS_TABLE_COLUMN_KEYS;
    default:
      return DEFAULT_KS_PROJECTS_TABLE_COLUMN_KEYS;
  }
};
const DEFAULT_KS_PROJECTS_TABLE_COLUMN_KEYS: ProjectTableColumn[] = [
  'ministryName',
  'projectNumber',
  'fundSheetNumber',
  'fundSheetBranchNumber',
  'beginningOfTheFundBalance',
  'ownershipRatio',
  ...(!isPS() ? (['isPublished'] satisfies ProjectTableColumn[]) : []),
];
const DEFAULT_KS_LOCAL_GOVERNMENT_PROJECTS_TABLE_COLUMN_KEYS: ProjectTableColumn[] =
  [
    'ministryName',
    'projectNumber',
    'fundSheetNumber',
    'fundSheetBranchNumber',
    ...(!isPS() ? (['isPublished'] satisfies ProjectTableColumn[]) : []),
  ];
const DEFAULT_KS_INVESTMENT_PROJECTS_TABLE_COLUMN_KEYS: ProjectTableColumn[] = [
  'ministryName',
  'projectNumber',
  'fundSheetNumber',
  'fundSheetBranchNumber',
  ...(!isPS() ? (['isPublished'] satisfies ProjectTableColumn[]) : []),
];

export const ALL_RS_PROJECTS_TABLE_COLUMN_KEYS: ProjectTableColumn[] = [
  'name',
  'isPublished',
  'inspectionByExternalExpertReviewType',
  ...(!isPS()
    ? ([
        'candidateReasonsOfInspectionByExternalExpert',
        'lastImplementedFiscalYear',
      ] satisfies ProjectTableColumn[])
    : []),
  'ministryName',
  'projectNumber',
  'startYear',
  'budgetData',
  'finalizedAmountForInitialBudget',
  'organizationLabel',
  'endYear',
  'purpose',
  'task',
  'previousYearExecutedAmounts',
  'previousYearExecutionRate',
  'nextYearRequestedAmount',
  'finalizedAmountForSupplementaryBudget',
  'mainPayment',
  'paymentAmount',
];

export const getAllKSProjectsTableColumnKeys = (
  fundSheetType: string | null,
) => {
  switch (fundSheetType) {
    case 'local-government':
      return ALL_KS_LOCAL_GOVERNMENT_PROJECTS_TABLE_COLUMN_KEYS;
    case 'investment':
      return ALL_KS_INVESTMENT_PROJECTS_TABLE_COLUMN_KEYS;
    default:
      return ALL_KS_PROJECTS_TABLE_COLUMN_KEYS;
  }
};

const ALL_KS_PROJECTS_TABLE_COLUMN_KEYS: ProjectTableColumn[] = [
  'name',
  'isPublished',
  'ministryName',
  'fundOwner',
  'fiscalYearOfCreation',
  'endDateOfNewApplicationReceiving',
  'scheduledEndDate',
  'administrativeExpenses',
  'previousYearTotalIncome',
  'previousYearTotalExpense',
  'amountReturnedToTheNationalTreasury',
  'fundSheetNumber',
  'fundSheetBranchNumber',
  'operationForms',
  'businessForms',
  'beginningOfTheFundBalance',
  'ownershipRatio',
  'mainPayment',
  'paymentAmount',
  'previousYearAdministrativeExpenseRate',
  'previousYearDivergenceRate',
];
const ALL_KS_LOCAL_GOVERNMENT_PROJECTS_TABLE_COLUMN_KEYS: ProjectTableColumn[] =
  [
    'name',
    'isPublished',
    'ministryName',
    'fiscalYearOfCreation',
    'endDateOfNewApplicationReceiving',
    'scheduledEndDate',
    'fundSheetNumber',
    'fundSheetBranchNumber',
    'operationForms',
    'businessForms',
  ];
const ALL_KS_INVESTMENT_PROJECTS_TABLE_COLUMN_KEYS: ProjectTableColumn[] = [
  'name',
  'isPublished',
  'ministryName',
  'fundSheetNumber',
  'fundSheetBranchNumber',
  'businessForms',
];
